import React from 'react';
import { ErrorMessage } from 'formik';
import ShiftEmployeesList from './ShiftEmployeesList';
import config from '../config';

export default ({
  values,
  employeesList,
  errors,
  status,
  touched,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
}) => {
  let submitButton = null;
  const { writeAccess } = config;

  if (writeAccess) {
    submitButton = (
      <button className="btn btn--primary shift-submit" type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Een moment...' : 'Ploeg opslaan'}
      </button>
    );
  }

  return (
    <div>
      <div className="row">
        <div className="col-6 col-lg-4">
          <div className="form-group">
            <strong>Naam dienst:</strong><br />
            <input className="form-control" type="text" onChange={handleChange} onBlur={handleBlur} name="shiftName" value={values.shiftName} disabled={!writeAccess} />
            <ErrorMessage name="shiftName" className="error-message" component="div" />
          </div>

          <div className="form-group">
            <strong>Project:</strong><br />
            <input className="form-control" type="text" onChange={handleChange} onBlur={handleBlur} name="projectName" value={values.projectName} disabled={true} />
            <ErrorMessage name="projectName" className="error-message" component="div" />
          </div>

          <div className="form-group">
            <strong>Projectnummer:</strong><br />
            <input className="form-control" type="text" onChange={handleChange} onBlur={handleBlur} name="projectIdentifier" value={values.projectIdentifier} disabled={true} />
            <ErrorMessage name="projectIdentifier" className="error-message" component="div" />
          </div>

          <div className="form-group row">
            <div className="col-8">
              <strong>Van:</strong><br />
              <input className="form-control" type="date" onChange={handleChange} onBlur={handleBlur} name="startDate" value={values.startDate} disabled={!writeAccess} />
              <ErrorMessage name="startDate" className="error-message" component="div" />
            </div>

            <div className="col-4">
              <strong>&nbsp;</strong><br />
              <input className="form-control" type="time" onChange={handleChange} onBlur={handleBlur} name="startDateTime" value={values.startDateTime} disabled={!writeAccess} />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-6 col-lg-8">
              <strong>Tot:</strong><br />
              <input className="form-control" type="date" onChange={handleChange} onBlur={handleBlur} name="endDate" value={values.endDate} disabled={!writeAccess} />
              <ErrorMessage name="endDate" className="error-message" component="div" />
            </div>

            <div className="col-4">
              <strong>&nbsp;</strong><br />
              <input className="form-control" type="time" onChange={handleChange} onBlur={handleBlur} name="endDateTime" value={values.endDateTime} disabled={!writeAccess} />
            </div>
          </div>
        </div>

        <div className="col-6 col-lg-8">
          <div className="form-group">
            <strong>Uitvoerder:</strong><br />
            <select className="custom-select" name="contractor" value={values.contractor ? values.contractor : ''} onChange={handleChange} onBlur={handleBlur} disabled={!writeAccess}>
              <option value="">Selecteer uitvoerder</option>
              {employeesList.map((employee) => {
                return (
                  <option value={employee.id} key={employee.id}>{employee.name}</option>
                );
              })}
            </select>
            <ErrorMessage name="contractor" className="error-message" component="div" />
          </div>

          <div className="form-group">
            <strong>Medewerkers </strong>
            {(values.requiredUsers > 0) ? (
              <small>({values.employees.length} van {values.requiredUsers} geselecteerd)</small>
            ) : (
              <small>({values.employees.length} geselecteerd)</small>
            )}
            <br />
            <ShiftEmployeesList employees={values.employees} employeesList={employeesList} handleChange={handleChange} />
            <ErrorMessage name="employees" className="error-message" component="div" />
          </div>
        </div>
      </div>

      <input type="hidden" name="id" value={values.id} onChange={handleChange} />

      {submitButton}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/forms/ShiftFormFields.js